import { combineReducers } from 'redux';
import { SET_ALL_VALUES } from '../actionType';

import Auth from './auth';
import Payer from './payer';
import Subscription from './subscription';
import Address from './address';
import Order from './order';
import Plan from './plan';
import Payment from './payment';
import Cupom from './cupom';
import Campaign from './campaign';
import GiftCode from './giftCode';
import VivoUser from './vivoUser';
import CmDrConsulta from './cmDrConsulta';
import SignatureChosen from './signatureChosen';
import Levelled from './levelled';
import Pharmaceutical from './pharmaceutical';

const appReducer = combineReducers({
	Auth,
	Payer,
	Subscription,
	Address,
	Order,
	Plan,
	Payment,
	Cupom,
	Campaign,
	GiftCode,
	VivoUser,
	CmDrConsulta,
	SignatureChosen,
	Levelled,
	Pharmaceutical
});

const rootReducer = (state, action) => {
	if (action.type === SET_ALL_VALUES && state.Payer.data.length == 0) {
		return {
			...state,
			...action.payload
		};
	}
	return appReducer(state, action);
};

export default rootReducer;
